import 'core-js';
import 'regenerator-runtime';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.min.css';

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from '@/config/vue-router';
import VueCookies from 'vue-cookies';
import Vuetify from '@/config/vuetify';
import Store from '@/config/store';
import alert from '@/pages/components/alert.vue';
import confirm from '@/pages/components/confirm.vue';
import dataTableCustomComponent from '@/pages/components/data-table-custom-component.vue';
import datePicker from '@/pages/components/date-picker.vue';
import App from '@/routes/App.vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

Vue.component('alert-component', alert);
Vue.component('confirm-component', confirm);
Vue.component('data-table-custorm-component', dataTableCustomComponent);
Vue.component('picker-date-picker-component', datePicker);
Vue.use(Vuex);
Vue.use(VueCookies);

const firebaseConfig = {
    apiKey: 'AIzaSyALCUSFYEf9YIn48oZ0EEn6dyp_F2STSYE',
    authDomain: 'study-go-8966e.firebaseapp.com',
    databaseURL: 'https://study-go-8966e-default-rtdb.firebaseio.com',
    projectId: 'study-go-8966e',
    storageBucket: 'study-go-8966e.appspot.com',
    messagingSenderId: '565225622382',
    appId: '1:565225622382:web:f37331923bf2f57a14cf7f',
    measurementId: 'G-SP3PJ4CMEV',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const firebaseAuth = firebaseApp.auth();
const firebaseDb = firebaseApp.database();

export { firebaseAuth, firebaseDb };
new Vue({
    el: '#app',
    render: (h) => h(App),
    vuetify: Vuetify,
    store: Store,
    router: VueRouter,
});
